import React from 'react'
import CountUp, { useCountUp } from 'react-countup';

const countData = [
  {
    number: "2.5",
    suffix: "m",
    desc: "Documents Managed Daily"
  },
  {
    number: "22",
    suffix: "k",
    desc: "Enterprise Workflows Enabled"
  },
  {
    number: "84",
    suffix: "+",
    desc: "Countries Served"
  },
  {
    number: "99",
    suffix: "%",
    desc: "Customer Satisfaction Rate"
  },
]

export default function AboutCounter() {
  useCountUp({
    ref: "counter",
    start: 0,
    end: 1234567,
    delay: 1000,
    duration: 3000,
  });

  return (
    <>
      <section className="about-counter-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h3 className="heading center-heading">Transforming the Way Enterprises Manage Information </h3>
            </div>
            {countData?.map((data, index) => (
              <div key={index} className="col-lg-3 col-md-3">
                <div className="home-counts">
                  <span><CountUp {...(index === 0 ? { decimals: 1 } : {})}  end={data?.number} enableScrollSpy/>{data?.suffix}</span>
                  <p dangerouslySetInnerHTML={{__html: data?.desc}}/>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
